// extracted by mini-css-extract-plugin
export default {"container":"ReferralItem_container__BmwDE","referral_container":"ReferralItem_referral_container__f+Hzb","title":"ReferralItem_title__gStua","desc":"ReferralItem_desc__EwRwW"};